// extracted by mini-css-extract-plugin
module.exports = {"heading":"LandownerReferralPage_heading__1L8xO","content":"LandownerReferralPage_content__2yoJe"};